export const barWrapper = 'flex flex-row flex-1 justify-evenly bg-uiBg';
export const levelWrapper = 'flex flex-row flex-1 items-center px-2 py-4';
